import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { toggleAffinityHighlight } from 'actions/feature/affinityGroups'

import { makeAffinityGroupSelector } from 'selectors/feature/affinityGroups'
import {
  makeConditionSelector,
  getCarryToType,
} from 'selectors/feature/conditions'
import {
  makeConditionSimulationSelector,
  getNodeCarrySimulationEvaluation,
  getTimerSimulationValueByUri,
} from 'selectors/feature/simulation'
import { getIsSixteenBitCanOutput } from 'selectors/feature/outputs'
import { makeGetHasErrors } from 'selectors/validation'
import { getIsSimulating } from 'selectors/navigator'
import { isUndefined } from 'utils/types'
import Condition from './Condition'

const makeMapStateToProps = () => {
  const querySelector = makeConditionSelector()
  const affinityGroupSelector = makeAffinityGroupSelector()
  const getHasErrors = makeGetHasErrors()
  const simulationSelector = makeConditionSimulationSelector()

  return (state, ownProps) => {
    const {
      ignoreCarry = false,
      selectedId,
      parentQueryUri,
      uri: conditionUri,
      conditionIndex,
      isFirst,
      isLast,
      fnId,
      condition: possibleCondition,
      isEditing,
    } = ownProps
    const condition =
      possibleCondition ||
      querySelector(state, {
        queryUri: conditionUri,
      })

    const { evaluationResult } = simulationSelector(state, {
      queryUri: conditionUri,
    })

    const isSimulating = getIsSimulating(state)

    const {
      uri,
      operator,
      edge,
      hysteresis,
      value,
      signal,
      inputUri,
      selectedInputDescription,
      numberOfBits,
      startBit,
      canId,
      translationType,
      translations,
      units,
      inputConfig,
      parentType,
      rungType,
      refQueryUri,
      carryType,
      result,
      subType,
      customDescription,
      uriOptionsByPosition,
    } = condition

    const carryToType = getCarryToType(state, {
      queryUri: parentQueryUri,
      refQueryUri,
      uri,
      fnId,
    })

    const carryToEvalutation = getNodeCarrySimulationEvaluation(state, {
      queryUri: refQueryUri,
    })

    const isSelected = selectedId === uri
    const isSixteenBitCanOutput = getIsSixteenBitCanOutput(state, {
      id: fnId,
    })
    const hasErrors = getHasErrors(state, { id: uri })

    const { affinityGroupNumber, highlightAffinity } = affinityGroupSelector(
      state,
      { id: inputUri }
    )

    const isSingleCondition =
      isUndefined(parentType) || !['timer', 'complex'].includes(parentType)

    const timerCarrySimulationValue =
      condition.refQueryUri &&
      isSimulating &&
      getTimerSimulationValueByUri(state, { queryUri: condition.refQueryUri })

    return {
      fnId,
      selectedInputDescription,
      inputConfig,
      rungType,
      uri,
      parentQueryUri,
      inputUri,
      operator,
      edge,
      hysteresis,
      value,
      result: Boolean(result),
      affinityGroupNumber,
      highlightAffinity,
      signal,
      isSelected,
      ignoreCarry,
      numberOfBits,
      startBit,
      canId,
      translationType,
      translations,
      units,
      selectedId,
      isSixteenBitCanOutput,
      hasErrors,
      isSingleCondition,
      isFirst,
      isLast,
      isEditing,
      conditionIndex,
      carryToType,
      carryToEvalutation,
      carryType,
      parentType,
      subType,
      evaluationResult,
      isSimulating,
      timerCarrySimulationValue,
      customDescription,
      uriOptionsByPosition,
    }
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleAffinityHighlight,
    },
    dispatch
  )

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { inputUri } = propsFromState

  const { toggleAffinityHighlight: toggleAffinity } = propsFromDispatch

  const onCarryIconClick = () => toggleAffinity(inputUri)

  return {
    ...ownProps,
    ...propsFromState,
    ...propsFromDispatch,
    onCarryIconClick,
  }
}

export default connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Condition)
